<template>
  <BModal
    id="modal-filters"
    ref="modal-filters"
    modal-class="modal-no-header-no-footer"
    size="xl"
    hide-header="hide-header"
    hide-footer="hide-footer"
    @shown="handleModalShown"
    @hidden="handleModalHidden"
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="close()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        v-if="segment"
        class="modal-title align-items-center text-center"
      >
        {{ __("Segmentação") }}:

        <input
          v-model="segment.name"
          class="segment-name-input w-60"
          type="text"
        >
      </h4>
      <h4
        v-else
        class="modal-title align-items-center text-center"
      >
        {{ __("Filtro avançado")
        }}<span
          class="ml-3"
        ><i
          v-if="loading"
          class="fa fa-spin fa-circle-o-notch"
        /></span>
      </h4>
      <form
        ref="form"
        class="px-4px"
        @submit.prevent="submitForm()"
      >
        <div
          v-if="!loading"
          ref="lead-filter"
          class="lead-filter pr-48px"
        >
          <div
            v-for="(row, index) in rows"
            class="filter"
          >
            <div class="row mx-n10px">
              <div
                v-if="index && isNewFilterStyle ()"
                class="pl-10px pr-5px col-lg-1"
              >
                <div class="form-group">
                  <select
                    v-model="rows[index].type"
                    class="p-3px mb-1 form-control"
                    :value="'where'"
                    :name="'filter[' + index + '][type]'"
                  >
                    <option value="where">
                      E
                    </option>
                    <option value="orWhere">
                      Ou
                    </option>
                  </select>
                </div>
              </div>
              <div class="px-8px col">
                <div class="form-group">
                  <InputFilterSelect
                    :key="JSON.stringify(rows[index])"
                    v-model="rows[index].filter"
                    :name="'filters[' + index + '][filter]'"
                    :filters="filters"
                    :rows="rows"
                    @input="clearRow(index)"
                    :removed-filters="removedFilters"
                  />
                </div>
              </div>
              <div
                v-if="!getFilter(rows[index].filter).hide_operators"
                class="px-10px col-lg-3"
              >
                <div class="form-group">
                  <select
                    v-model="rows[index].operator"
                    class="form-control"
                    :name="'filters[' + index + '][operator]'"
                  >
                    <option value="">
                      {{ __("Regra") }}
                    </option>
                    <option
                      v-for="(name, operator) in getFilter(rows[index].filter)
                        .operators || operators"
                      :value="operator"
                    >
                      {{ __(name) }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="px-10px"
                :class="[
                  getFilter(rows[index].filter).hide_operators
                    ? 'col-lg-6'
                    : 'col-lg-3',
                ]"
              >
                <div class="form-group">
                  <div
                    :id="`multiselect-${index}`"
                    v-if="getFilter(rows[index].filter).multiselect"
                    class="filter-multiselec"
                  >
                    <Multiselect
                      :id="index"
                      v-model="selected[index]"
                      :key="index"
                      open-direction="bottom"
                      :max="['tag', 'mail.opened'].includes(rows[index].filter) ? false : 5"
                      :label="getFilter(rows[index].filter).multiselect.label"
                      :track-by="
                        getFilter(rows[index].filter).multiselect.track
                      "
                      :placeholder="getFilter(rows[index].filter).placeholder"
                      :options="getFilter(rows[index].filter).options"
                      :multiple="true"
                      :searchable="true"
                      :show-labels="false"
                      :hide-selected="true"
                      :preserve-search="true"
                      :internal-search="true"
                      :show-no-options="false"
                      @input="updateQuery"
                      @open="handleMultiselectDropdownOpened"
                      class="advanced-filter-multiselect"
                      ref="advanced-filter-multiselect"
                      :class="{ 'no-operator': !hasOperator(rows[index].filter) }"
                    >
                      <div
                        slot="tag"
                        slot-scope="{ option, search, remove }"
                        class="multiselect__tag"
                        v-b-tooltip="{
                          customClass: 'ml-2 lead-tag-tooltip'
                        }"
                        :title="option.name"
                      >
                        <span>
                          {{ option.name }}
                        </span>
                        <i
                          aria-hidden="true"
                          tabindex="1"
                          class="multiselect__tag-icon"
                          @click="remove(option)"
                        ></i>
                      </div>
                      <span
                        slot="maxElements"
                      >Número máximo de seleções atingida.</span>
                    </Multiselect>
                  </div>
                  <select
                    v-else-if="hasOptions(rows[index].filter)"
                    v-model="rows[index].query"
                    class="form-control"
                    :name="'filters[' + index + '][query]'"
                  >
                    <option value="">
                      {{ __("Selecione a opção") }}
                    </option>
                    <option
                      v-for="(name, option) in getFilter(rows[index].filter)
                        .options"
                      :value="option"
                    >
                      {{ __(name) }}
                    </option>
                  </select>
                  <select
                    v-else-if="shouldShowDisabledSelect(rows[index].filter)"
                    class="form-control disabled"
                  >
                    <option value="">{{ __("Sem opções disponíveis") }}</option>
                  </select>
                  <InputDaterange
                    v-else-if="getFilter(rows[index].filter).filter === 'range'  || getFilter(rows[index].filter).filter === 'closed_at'"
                    v-model="rows[index].query"
                    custom-class="input-date-range-leads-filter"
                    theme="readonly"
                    ref="input-date-range-leads-filter"
                    :placeholder="__('Clique para selecionar datas')"
                    :name="'filters[' + index + '][query]'"
                    @update="(value) => (rows[index].query = value)"
                  />
                  <input
                    v-else-if="!hideOptions(rows[index].filter)"
                    v-model="rows[index].query"
                    class="form-control"
                    type="text"
                    :placeholder="getFilter(rows[index].filter).placeholder"
                    :name="'filters[' + index + '][query]'"
                  >
                </div>
              </div>
              <a
                v-if="rows.length > 1"
                class="delete"
                href="#"
                @click="removeRow(row)"
              >
                <IconTrash /></a>
            </div>
          </div>
          <div class="form-group">
            <a
              class="add"
              href="#"
              @click="addRow()"
            ><i class="fa fa-plus mr-2" /> {{ __("Adicionar condição") }}</a>
          </div>
          </div>
          <div class="form-group">
            <hr>
          </div>
          <div class="mb-4">
            <div
              v-if="segment"
              class="form-group"
            >
              <div class="circular-purple-checkbox">
                <input
                  id="check-private"
                  v-model="private"
                  type="checkbox"
                >
                <label
                  class="form-check-label"
                  for="check-private"
                >{{
                  __("Segmentação privada")
                }}</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <select
              v-if="!isNewFilterStyle()"
              v-model="type"
              class="form-control"
              name="filters[type]"
            >
              <option
                v-for="(name, selectType) in types"
                :value="selectType"
              >
                {{ __(name) }}
              </option>
            </select>
          </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="salesflow-btn salesflow-btn-secondary f-w-500"
            type="submit"
            :disabled="sending"
          >
            <i
              v-if="sending"
              class="fa fa-circle-o-notch fa-spin"
            /><span v-else>{{
              segment ? __("Salvar & Filtrar") : __("Filtrar")
            }}</span>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['inputs', 'segment'],

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      loading: true,
      sending: false,
      type: null,
      types: {},
      private: false,
      rows: [],
      filters: [],
      removedFilters: [],
      operators: [],
      selected: {},
      scrollPosition: 0,
      observer: null,
    };
  },

  mounted () {
    if (this.segment && this.segment.user_id) {
      this.private = true;
    }

    this.getFilters();

    Vue.nextTick(() => this.loadCurrentFilters());

    if (! Bus._events.advancedFiltersButtonToggled) {
      Bus.$on('advancedFiltersButtonToggled', () => this.open());
    }

    Bus.$on('filterChanged', (filter, oldFilter) => this.filterChanged(filter, oldFilter));
  },

  methods: {
    open () {
      this.$refs['modal-filters'].show();
    },

    close () {
      this.$refs['modal-filters'].hide();
    },

    clearRow (index) {
      this.rows[index].query = '';
      this.rows[index].operator = '';

      this.selected[index] = [];
    },

    getFilters () {
      const segmentId = this.getSegmentId();

      const query = segmentId ?
        `segment_id=${segmentId}` : '';

      this.$http.get(`/lead/filter?${query}`).then(({ data }) => {
        this.types = data.types;
        this.filters = data.filters;
        this.operators = data.operators;

        if (typeof this.inputs.type !== 'undefined') {
          this.type = this.inputs.type;
        }

        this.loadMultiselect();
      });
    },

    getSegmentId () {
      const params = new URLSearchParams(window.location.search);

      return params.get('segment');
    },

    loadCurrentFilters () {
      this.rows = _.filter(this.inputs, (input) => input && input.query).map((input) => {
        input.filter = input.filter || '';
        input.operator = input.operator || '=';
        input.query = this.decode(input.query) || '';
        input.type = input.type || 'where';

        return input;
      });

      if (this.rows.length === 0) {
        this.addRow();
      }

      this.loading = false;
    },

    loadMultiselect () {
      this.selected = {};

      this.rows.forEach((row, index) => {
        const filter = this.getFilter(row.filter);
        let queries;

        if (filter.multiselect) {
          if (filter?.customCheckbox && row.query.includes('|')) {
            queries = row.query.split('|');
          } else {
            queries = row.query.split(',');
          }

          this.selected[index] = filter.options.filter(
            (option) => queries.indexOf(option[filter.multiselect.track].toString()) > -1,
          );

          this.removeFromFilters(filter);
        }
      });
    },

    // Checks if filter has general filter type attribute, or type per filter
    isNewFilterStyle () {
      return ! ['any'].includes(this.inputs.type);
    },

    decode (encoded) {
      const el = document.createElement('textarea');

      el.innerHTML = encoded;

      return el.value;
    },

    addRow (row) {
      this.rows.push(
        row || {
          filter: '',
          operator: '',
          query: '',
          type: 'where', // initializes all filters as "and"
        },
      );
    },

    removeRow (row) {
      const filter = this.getFilter(row.filter);

      if (filter.multiselect) {
        this.addToFilters(filter);
      }

      this.rows.splice(this.rows.indexOf(row), 1);

      this.loadMultiselect();
    },

    getFilter (filter) {
      return (
        this.filters.find((object) => object.filter == filter)
        || this.removedFilters.find((object) => object.filter == filter)
        || {}
      );
    },

    hasOperator (filter) {
      const filterObj = this.getFilter(filter);

      if (Array.isArray(filterObj.operators)) {
        return filterObj.operators.length;
      }

      return true;
    },

    addToFilters (filter) {
      // let index = this.removedFilters.indexOf(filter);
      // if (0 <= index) {
      //   this.filters.unshift(filter);
      //   this.removedFilters.splice(index, 1);
      // }
    },

    removeFromFilters (filter) {
      // let index = this.filters.indexOf(filter);
      // if (0 <= index) {
      //   this.removedFilters.unshift(filter);
      //   this.filters.splice(index, 1);
      // }
    },

    filterChanged (filter, oldFilter) {
      if (oldFilter.multiselect) {
        this.addToFilters(oldFilter);
      }

      if (filter.multiselect) {
        this.removeFromFilters(filter);
      }
    },

    hideOptions (filter) {
      return this.getFilter(filter).options === false;
    },

    hasOptions (filter) {
      return _.size(this.getFilter(filter).options) > 0;
    },

    updateQuery (value, index) {
      let filterInfo = this.getFilter(this.rows[index].filter);
      const { track } = filterInfo.multiselect;
      let customCheckbox = filterInfo?.customCheckbox;

      if (customCheckbox) {
        this.rows[index].query = value.map((item) => item[track]).join('|');
      } else {
        this.rows[index].query = value.map((item) => item[track]).join(',');
      }

      this.addRow('a ugly little hack');
      this.removeRow('a ugly little hack');
    },

    submitForm () {
      this.sending = true;

      if (! this.segment) {
        let query = this.rows
          .map((row, index) => {
            let filters = '';

            for (let [key, value] of Object.entries(row)) {
              value = encodeURIComponent(value).replace(
                /[!'()*]/g,
                (c) => `%${c.charCodeAt(0).toString(16)}`,
              );

              filters += `filters[${index}][${key}]=${value}&`;
            }

            return filters;
          })
          .join('');

        query += this.type ? `filters[type]=${this.type}` : '';

        window.location.href = `/lead/all?${query}`;

        return;
      }

      this.$http
        .put(`/lead/segment/${this.segment.id}`, {
          filters: this.rows,
          type: this.type,
          name: this.segment.name,
          private: this.private,
        })
        .then((response) => {
          window.location.href = response.data.url;
        })
        .catch((response) => {
          if (response?.status == 422 && response?.data?.message) {
              return Alert.error(response?.data?.message);
          }


          Alert.error(
            this.__(
              'Houve um erro ao filtrar os leads. Tente novamente em instantes.',
            ),
          );
        }).finally(() => { this.sending = false; });
    },

    handleMultiselectDropdownOpened(elementId) {
      const multiselect = document.getElementById(`multiselect-${elementId}`);
      const dropdown = multiselect.querySelector('.multiselect__content-wrapper');

      this.$nextTick(() => {
        const multiselectRect = multiselect.getBoundingClientRect();
        const endOfMultiselect = multiselectRect.top + multiselectRect.height;

        const scrollTop = this.$refs['lead-filter'].scrollTop;
        this.scrollPosition = scrollTop;

        dropdown.style.top = `${endOfMultiselect}px`;
      });
    },

    handleModalShown () {
      this.observer = new MutationObserver(this.observerHandler);

      this.observer.observe(this.$refs['form'], {attributes: false, childList: true, characterData: false, subtree: true});

      this.$refs['lead-filter'].addEventListener('wheel', this.handleWheel);
      this.$refs['lead-filter'].addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    },

    handleModalHidden () {
      this.observer.disconnect();
      window.removeEventListener('resize', this.handleResize);
    },

    handleWheel () {
      setTimeout(() => {
        const scrollTop = this.$refs['lead-filter'].scrollTop;

        if (scrollTop === this.scrollPosition) {
          return;
        }

        this.scrollPosition = scrollTop;

        this.$refs['advanced-filter-multiselect'].forEach((multiselect) => {
          multiselect.deactivate();
        });
      }, 50);
    },

    handleScroll () {
      setTimeout(() => {
        const components = this.$refs['input-date-range-leads-filter'];
        if (!components) {
          return;
        }

        components.forEach((component) => {
          const dropdown = component.$children?.find((child) => {
            return child.$el?.classList?.contains('vue-daterange-picker');
          });

          if (!dropdown) {
            return;
          }

          dropdown.open = false;
        });
      }, 5);
    },

    handleResize () {
      const components = this.$refs['input-date-range-leads-filter'];
      if (!components) {
        return;
      }

      components.forEach((component) => {
        component.$el && this.adjustInputDateRangePosition(component.$el);
      });
    },

    observerHandler (mutations) {
      const mutation = mutations.find((mutation) => {
        const inputElement = mutation.target;
        const dropdownElement = Array.from(mutation.addedNodes).find((node) => {
          return node.classList?.contains('daterangepicker');
        });

        if (!inputElement || !dropdownElement) {
          return false;
        }

        return inputElement.classList?.contains('input-date-range-leads-filter');
      });

      if (!mutation) {
        return;
      }

      return this.adjustInputDateRangePosition(mutation.target);
    },

    adjustInputDateRangePosition (element) {
      const dropdownElement = element.querySelector('.daterangepicker');

      if (!dropdownElement) {
        return;
      }

      const bounds = element.getBoundingClientRect();

      const top = bounds.y + bounds.height + 4;
      const left = bounds.x + (bounds.width / 2);

      dropdownElement.style.top = `${top}px`;
      dropdownElement.style.left = `${left}px`;
    },

    shouldShowDisabledSelect(filter) {
      const filterObj = this.getFilter(filter);
      return filterObj && 
             filterObj.hasCustomOptions && 
             (!filterObj.options || filterObj.options.length === 0);
    },
  },
};
</script>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .lead-filter {
    height: 266px;
    overflow-y: scroll;
    padding: 8px;

    select.form-control {
      option {
        @include salesflow-subtitle($color: $salesflow-font-dark);
      }
    }

    .input-date-range-leads-filter {
      .daterangepicker.show-calendar.show-ranges {
        position: fixed;
        transition: 0.01s;
        transition-timing-function: cubic-bezier(0, 0, 0, 1);
      }

      .reportrange-text div {
        display: flex;
      }

      .input-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        white-space: nowrap;
        gap: 8px;
      }

      .input-group input {
        flex-grow: 1;
        padding: 0;
        padding-top: 2px;
        border: none;
        background: transparent;
        cursor: pointer;
      }
    }
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
</style>
